import type { VesselPerformanceKind, VesselPerformanceRow } from "../models/vessel-data.models";

const labels: Record<VesselPerformanceKind, string> = {
  ladenEco: "Laden ECO",
  ballastEco: "Ballast ECO",
  ladenFull: "Laden FULL",
  ballastFull: "Ballast FULL",
};

const value = (entry: number | string | null) => entry ?? "—";

// Mirrors the four fixed performance rows and keeps unavailable semantic-model status values visibly empty.
const VesselPerformanceTable = ({ rows }: { rows: VesselPerformanceRow[] }) => (
  <div className="overflow-x-auto p-4">
    <table className="w-full min-w-[950px] text-xs" data-test="vessel-data-performance-table">
      <thead><tr className="border-b text-left text-[10px] uppercase text-gray-500">{["Condition", "Clean hull speed", "Total cons", "Current speed", "Current vs clean %", "CP speed / cons", "Clean performance", "Current performance"].map((heading) => <th key={heading} className="px-3 py-2">{heading}</th>)}</tr></thead>
      <tbody>{rows.map((row) => <tr key={row.condition} className="border-b border-gray-100 dark:border-gray-700"><td className="px-3 py-3 font-semibold">{labels[row.condition]}</td><td className="px-3 py-3">{value(row.cleanHullSpeed)}</td><td className="px-3 py-3">{value(row.totalConsumption)}</td><td className="px-3 py-3">{value(row.currentSpeed)}</td><td className="px-3 py-3">{row.currentVsCleanPercent === null ? "—" : `${row.currentVsCleanPercent}%`}</td><td className="px-3 py-3">{row.cpSpeed === null && row.cpConsumption === null ? "—" : `${value(row.cpSpeed)} / ${value(row.cpConsumption)}`}</td><td className="px-3 py-3 text-green">{value(row.cleanPerformance)}</td><td className="px-3 py-3 text-green">{value(row.currentPerformance)}</td></tr>)}</tbody>
    </table>
  </div>
);

export default VesselPerformanceTable;
